import styled from '@emotion/styled';

export const CardContainer = styled.div`
	padding: 4rem 2.4rem;
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	gap: 0.8rem;
	border: 1px solid #e9ecef;
	border-right: none;
	border-bottom: none;
	cursor: pointer;
	:nth-of-type(3),
	:nth-of-type(6) {
		border-right: 1px solid #e9ecef;
	}
	:nth-of-type(4),
	:nth-of-type(5),
	:nth-of-type(6) {
		border-bottom: 1px solid #e9ecef;
	}
	@media screen and (max-width: 1100px) {
		flex-direction: column;
		justify-content: center;
		padding: 2.4rem;
		border-right: none;
		border-bottom: none;
		:nth-of-type(4) {
			border-left: none;
			border-bottom: none;
		}
		:nth-of-type(2),
		:nth-of-type(4),
		:nth-of-type(6) {
			border-right: 1px solid #e9ecef;
		}
		:nth-of-type(5),
		:nth-of-type(6) {
			border-bottom: 1px solid #e9ecef;
		}
	}
	@media screen and (max-width: 420px) {
		border-bottom: none;
		:nth-of-type(1),
		:nth-of-type(5) {
			border-right: 1px solid #e9ecef;
		}
		:nth-of-type(4) {
			border-left: 1px solid #e9ecef;
		}
		:nth-of-type(5) {
			border-bottom: none;
		}
		:last-child {
			border-bottom: 1px solid #e9ecef;
		}
	}
`;
